import React from 'react';

export const LoadingIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill-rule="evenodd"
      d="M18.064 9.948l1.518-.507a8 8 0 1 1-5.109-5.052l-.506 1.519a6.4 6.4 0 1 0 4.097 4.04z"
    />
  </svg>
);
